module.exports = __webpack_public_path__ + "img/j5.a3a3eeb1.png";